import { useState } from "react";
import Modal from "../common/Modal";
import { hashPassword } from "../../common/api/auth";
import { useToast } from "../../hooks/useToast";


function ModalEditUser({ user, onClose, onSave, hasManagementPermissions }) {
  const [email, setEmail] = useState(user.EMAIL || "");
  const [enabled, setEnabled] = useState(user.ACTIVO === 1 || user.ACTIVO === "1");
  const [password, setPassword] = useState("");
  const toast = useToast();


  const handleSubmit = async () => {
    if (!password) {
      toast.error(
        "Debes introducir tu contraseña actual para guardar los cambios."
      );
      return;
    }

    if (!email.trim()) {
      toast.error("El email no puede estar vacío.");
      return;
    }

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isValidEmail) {
      toast.error("Introduce un email válido.");
      return;
    }

    try {
      const CURR_PASS_HASH = await hashPassword(password);

      let updatedUser = {
        COD_ID: user.COD_ID,
        USER: user.USER,
        EMAIL: email.trim(),
        //ACTIVO: enabled ? "1" : "0",
        //GRUPOS: user.GRUPOS ?? [],
        //CURR_PASS_HASH,
      };
       if (hasManagementPermissions && password.trim()) {
        updatedUser.CURR_PASS_HASH = await hashPassword(password);
        updatedUser.ACTIVO = enabled ? "1" : "0";
      }
      // console.log("📤 Payload inviato:", updatedUser); // ✅ DEBUG
      const success = await onSave(updatedUser);
      //console.log("📥 Risposta onSave:", success); // ✅ DEBUG
      if (success) {
        toast.success("Cambios guardados correctamente.");
        onClose();
      } else {
        toast.error("La contraseña actual no es correcta. No se pudo guardar el cambio.");
      }
    } catch (err) {
      toast.error(err.message || "Error al guardar cambios.");
      console.error("Error al guardar:", err);
    }
  };



  return (
    <Modal title={`Modificar usuario: ${user.USER}`} onClose={onClose}>
      <div className="input-group">
        <label className="label">Usuario</label>
        <input className="input" value={user.USER} disabled />
      </div>

      <div className="input-group">
        <label className="label">Email</label>
        <input
          className="input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={user.EMAIL}
          disabled={hasManagementPermissions}
        />
      </div>
      {hasManagementPermissions && 
            <div className="input-group">
              <label className="label">Usuario habilitado</label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={enabled}
                  onChange={(e) => setEnabled(e.target.checked)}
                />
                Activo
              </label>
            </div>

      }


      <div className="input-group">
        <label className="label">
          Introduzca su contraseña para guardar los cambios
        </label>
        <input
          className="input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <div className="input-group_row" style={{ justifyContent: "center", gap: "1rem" }}>
        <span className="boton_opciones" onClick={handleSubmit}>
          Aceptar
        </span>
        <span className="boton_cancelar" onClick={onClose}>
          Cancelar
        </span>
      </div>
    </Modal>
  );
}

export default ModalEditUser;
